import { Campaign } from '@skyrise-eng/types';
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { buildQueryString } from '@/utils';

// Define a service using a base URL and expected endpoints
export const campaignApi = createApi({
  reducerPath: 'campaignApi',
  baseQuery,
  endpoints: (builder) => ({
    getCampaignList: builder.query<Campaign[], { client: string }>({
      query: (params) => `/campaigns/api/v1?${buildQueryString(params)}`
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetCampaignListQuery } = campaignApi;
